import { IAddOrganizationMemberParams, ICreateOrganizationParams, IRemoveOrganizationMemberParams, IUpdateOrganizationParams, IVerifyOrganizationMemberParams } from '../redux/organization/actions.organization';
import { call } from './helpers/tutorCalls';

export const OrganizationApi = {
    createOrganization: (param: ICreateOrganizationParams) => {
        return call('createOrg', param);
    },

    updateOrganization: (param: IUpdateOrganizationParams) => {
        return call('updateOrg', param);
    },

    removeOrganization: () => {
        return call('removeOrg', {});
    },

    addOrganizationMember: (param: IAddOrganizationMemberParams) => {
        return call('addOrgMember', { userEmail: param.email });
    },

    removeOrganizationMember: (param: IRemoveOrganizationMemberParams) => {
        return call('removeOrgMember', { userEmail: param.email });
    },

    verifyOrganizationMember: (param: IVerifyOrganizationMemberParams) => {
        return call('orgMemberAccept', { hex: param.code });
    },
};